<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="商品ID" prop="productId">
        <a-input v-model="form.productId" placeholder="请输入商品ID" />
      </a-form-model-item>
      <a-form-model-item label="套餐类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">weekly_pro</a-radio>
          <a-radio :value="2">weekly_max</a-radio>
          <a-radio :value="3">weekly_ultra</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price">
        <a-input-number :min="0" :step="0.01" v-model="form.originalPrice" placeholder="价格" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item label="划线价" prop="originalPrice">
        <a-input-number :min="0" :step="0.01" v-model="form.originalPrice" placeholder="请输入划线价" style="width: 100%;" />
      </a-form-model-item>
      <a-form-model-item label="倒计时(秒)" prop="countdown">
        <a-input-number :min="0" v-model="form.countdown" placeholder="请输入倒计时时长(秒)" />
      </a-form-model-item>
      <a-form-model-item label="总共可获得积分" prop="totalCredits">
        <a-input-number :min="0" v-model="form.totalCredits" placeholder="请输入总共可获得积分" />
      </a-form-model-item>
      <a-form-model-item label="立刻获得积分" prop="instantCredits">
        <a-input-number :min="0" v-model="form.instantCredits" placeholder="请输入立刻获得积分" />
      </a-form-model-item>
      <a-form-model-item label="每天获得积分" prop="dailyCredits">
        <a-input-number :min="0" v-model="form.dailyCredits" placeholder="请输入每天获得积分" />
      </a-form-model-item>

      <a-divider>角标文案（多语言）</a-divider>
      <a-form-model-item label="中文角标" prop="remarkZh">
        <a-input v-model="form.remarkZh" placeholder="请输入中文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="英文角标" prop="remarkEn">
        <a-input v-model="form.remarkEn" placeholder="请输入英文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="日文角标" prop="remarkJa">
        <a-input v-model="form.remarkJa" placeholder="请输入日文角标文案" />
      </a-form-model-item>
      <a-form-model-item label="印尼角标" prop="remarkId">
        <a-input v-model="form.remarkId" placeholder="请输入印尼角标文案" />
      </a-form-model-item>
      <a-form-model-item label="葡语角标" prop="remarkPt">
        <a-input v-model="form.remarkPt" placeholder="请输入葡语角标文案" />
      </a-form-model-item>
      <a-form-model-item label="西语角标" prop="remarkEs">
        <a-input v-model="form.remarkEs" placeholder="请输入西语角标文案" />
      </a-form-model-item>

      <a-form-model-item label="排序" prop="sort">
        <a-input-number :min="0" v-model="form.sort" placeholder="请输入排序值" />
      </a-form-model-item>
      <a-form-model-item label="是否启用" prop="isOpen">
        <a-switch checked-children="启用" un-checked-children="关闭" :checked="form.isOpen === 1"
          @change="val => form.isOpen = val ? 1 : 0" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMenu, addMenu, updateMenu } from '@/api/vip/menu'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        productId: null,
        type: null,
        countdown: null,
        remarkZh: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        price: null,
        originalPrice: null,
        totalCredits: null,
        instantCredits: null,
        dailyCredits: null,
        sort: null,
        isOpen: null,
        createTime: null,
        updateTime: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        productId: [
          { required: true, message: '商品ID不能为空' }
        ],
        type: [
          { required: true, message: '套餐类型不能为空' }
        ],
        price: [
          { required: true, message: '价格不能为空' }
        ],
        originalPrice: [
          { required: true, message: '划线价不能为空' }
        ],
        totalCredits: [
          { required: true, message: '总共可获得积分不能为空' }
        ],
        instantCredits: [
          { required: true, message: '立刻获得积分不能为空' }
        ],
        dailyCredits: [
          { required: true, message: '每天获得积分不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        productId: null,
        type: null,
        countdown: null,
        remarkZh: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        price: null,
        originalPrice: null,
        totalCredits: null,
        instantCredits: null,
        dailyCredits: null,
        sort: null,
        isOpen: null,
        createTime: null,
        updateTime: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMenu({ "id": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMenu(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMenu(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
